
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { BASEURL, UPDATE_AGENT_PASSWORD } from '../constants';

const ChangePassword = () => {
    const [data, setData] = useState({});
    const [passwordVisible, setPasswordVisible] =useState(false);
    const [pass1,setPass1]=useState('')
    const [pass2,setPass2]=useState('')
    const [pass3,setPass3]=useState('')
    const [pass_check,setPass_check]=useState(false)
    const[isSubmit,setSubmit]=useState(false)
    const[pass_show,setpass]=useState(false)
    const[pass_show2,setpass2]=useState(false)
    const [passwordError,setPasswordError]=useState(false)
    const [popUpMessage, setPopUpMessage] = useState({ type: '', text: '' });

    const navigate=useNavigate()
    useEffect(() => {
        if(pass2 !== pass3){
            setPass_check(true)
        } else {
            setPass_check(false)
        }
    }, [pass2, pass3])

    const handlecheck= async () => {
     if(passwordError===false)
    {
    
        if(pass2 === pass3)
        {   
            setSubmit(true)
            try {
                let agentid = localStorage.getItem("agentId");
                const temp =  await axios.get(UPDATE_AGENT_PASSWORD + `/${agentid}?currentpass=${encodeURIComponent(pass1)}&newpass=${encodeURIComponent(pass2)}`)
                setPopUpMessage({ type: 'success', text: temp.data.message })
                setTimeout(() => {
                    navigate("/dashboard");
                }, 3000);
            } catch (error) {
            setPopUpMessage({ type: 'error', text: error.response.data.message })
            
            }
            finally{
                setPass1('')
                setPass2('')
                setPass3('')
                setSubmit(false)
            }
        }
        else{
            setPopUpMessage({ type: 'error', text: "Password do not match" })
    
        }
                        
    }
    else{
        // toast.error('Invalid Password Format')
        setPopUpMessage({ type: 'error', text: "Invalid Password Format" })
    }

      
    }
    const togglepassw=()=>{
        setpass(prevState=>!prevState)
    }
    const togglepassw2=()=>{
        setpass2(prevState=>!prevState)
    }

    const validatePasswords = () => {
        console.log(pass2)
        const isValid = pass2.length >= 8 && /[A-Z]/.test(pass2) && /[a-z]/.test(pass2) && /\d/.test(pass2);
        setPasswordError(!isValid);
        return isValid;
    };
    const handlePasswordChange = (e) => {
        setPass2(e.target.value);
        validatePasswords();
    };
 
  return (
   <>
      <div className="min-h-[calc(100vh-150px)] bg-slate-50 flex items-center justify-center px-4 py-10 dark:bg-black">
            <div className="flex flex-col items-center w-full">

                {/* popUpMessage */}
                {popUpMessage.text && (
                    <div className="fixed top-4 right-4 z-50 mt-10 mr-4 max-w-sm w-full">
                        <div
                            className={`border px-4 py-3 rounded relative shadow-md ${
                                popUpMessage.type === 'success'
                                    ? 'bg-green-100 border-green-400 text-green-700'
                                    : 'bg-red-100 border-red-400 text-red-700'
                            }`}
                            role="alert"
                        >
                            <span className="block sm:inline">{popUpMessage.text}</span>
                            <button
                                className="absolute top-0 bottom-0 right-0 px-4 py-3"
                                onClick={() => setPopUpMessage({ type: '', text: '' })}
                            >
                                <span className={popUpMessage.type === 'success' ? 'text-green-700' : 'text-red-700'}>
                                    &times;
                                </span>
                            </button>
                        </div>
                    </div>
                )}

                <div className="w-full max-w-[520px] bg-white border border-slate-200 shadow-sm p-6 rounded-2xl dark:bg-white/5 dark:text-gray-100 dark:border-neutral-700">
                    <h2 className="text-lg text-center font-medium text-slate-900 mb-6 dark:text-white">Change Password</h2>

                    <div className="flex flex-col gap-6">
                        {/* Old password */}
                        <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2 dark:text-gray-200">
                            Old password
                        </label>
                        <div className="flex relative">
                            <input
                            className="w-full font-normal px-3 py-2 rounded-lg dark:placeholder:text-gray-500 dark:border-neutral-700 dark:bg-[#1f1f1f] dark:text-gray-100 focus:outline-none text-slate-900 placeholder-slate-400 border border-slate-300 focus:border-blue-500 focus:ring-1 focus:border-transparent"
                            placeholder="Enter old password"
                            type={pass_show ? "text" : "password"}
                            value={pass1}
                            onChange={(e) => setPass1(e.target.value)}
                            size="large"
                            />
                            <button
                            type="button"
                            className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-slate-700"
                            onClick={togglepassw}
                            >
                            {pass_show ? <FaEye /> : <FaEyeSlash />}
                            </button>
                        </div>
                        </div>

                        {/* New password */}
                        <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2 dark:text-gray-200">
                            New password
                        </label>
                        <div className="flex relative">
                            <input
                            className={`w-full font-normal px-3 py-2 rounded-lg focus:outline-none text-slate-900 placeholder-slate-400 border ${
                                pass_check ? "border-red-400" : "border-slate-300"
                            } focus:border-transparent focus:ring-1 focus:ring-blue-500 dark:placeholder:text-gray-500 dark:border-neutral-700 dark:bg-[#1f1f1f] dark:text-gray-100`}
                            status={pass_check ? "error" : ""}
                            placeholder="Enter new password"
                            value={pass2}
                            onChange={handlePasswordChange}
                            type={pass_show2 ? "text" : "password"}
                            size="large"
                            />
                            <button
                            type="button"
                            className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-slate-700"
                            onClick={togglepassw2}
                            >
                            {pass_show2 ? <FaEye /> : <FaEyeSlash />}
                            </button>
                        </div>

                        <div className="mt-1">
                            <span className="text-xs text-red-500 dark:text-red-600/90">
                            {passwordError &&
                                "Password must include a number, uppercase letter, lowercase letter, and special character"}
                            </span>
                        </div>
                        </div>

                        {/* Confirm password */}
                        <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2 dark:text-gray-200">
                            Confirm password
                        </label>
                        <div className="flex relative">
                            <input
                            className={`w-full font-normal px-3 py-2 rounded-lg focus:outline-none text-slate-900 placeholder-slate-400 border ${
                                pass_check ? "border-red-400" : "border-slate-300"
                            } focus:border-blue-500 focus:ring-1 focus:border-transparent dark:placeholder:text-gray-500 dark:border-neutral-700 dark:bg-[#1f1f1f] dark:text-gray-100`}
                            status={pass_check ? "error" : ""}
                            placeholder="Re-enter new password"
                            value={pass3}
                            onChange={(e) => setPass3(e.target.value)}
                            size="large"
                            type={pass_show2 ? "text" : "password"}
                            />
                            <button
                            type="button"
                            className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-slate-700"
                            onClick={togglepassw2}
                            >
                            {pass_show2 ? <FaEye /> : <FaEyeSlash />}
                            </button>
                        </div>
                        </div>

                        <button
                        type="button"
                        onClick={handlecheck}
                        disabled={isSubmit}
                        className="mt-2 w-full font-semibold px-3 py-2.5 rounded-lg text-white bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 dark:bg-blue-500 dark:hover:bg-blue-600 dark:focus:ring-blue-300 focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                        {isSubmit ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default ChangePassword
